const cutFromString = (str: string, subStr: string, keepSubStr?: boolean) => {
  const index = str.indexOf(subStr)
  if (index !== -1) {
    return str.substring(0, index + (keepSubStr ? subStr.length : 0))
  }
  // Return the original string if the substring is not found
  return str
}

export default cutFromString
